import React from 'react';
import ReactDOM from 'react-dom/client';

import './global.css';

import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import LoginPage from './pages/LoginPage';
import CreateAccount from './pages/CreateAccount';
import HealthCheck from './pages/HealthCheck';
import AuthWrapper from './pages/AuthWrapper';
import AdminRouter from './pages/AdminRouter';
import AdminToolsPage from './pages/AdminToolsPage';
import ProfilePage from './pages/ProfilePage';
import CreditsPage from './pages/CreditsPage';
import TutorialPage from './pages/TutorialPage';
import { AudioProvider } from './audio/AudioProvider';

import { BrowserRouter } from "react-router-dom";
import {Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from './AuthProvider';
import { GameStateProvider } from './game/context/GameStateContext';

const App: React.FC = () => {

  return (
    <BrowserRouter>
      <AuthProvider>
        <AudioProvider>
          <Routes>
            {/* Public routes - no authentication required */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/createaccount" element={<CreateAccount />} />
            <Route path="/health" element={<HealthCheck />} />

            {/* Admin only */}
            <Route element={<AdminRouter />}>
              <Route path="/admin" element={<AdminToolsPage />} />
            </Route>
          
            {/* Routes under /: use relative paths so static segments (credits, tutorial, home, profile) rank above :roomCode */}
            <Route path="/" element={<AuthWrapper />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="home" element={<HomePage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="credits" element={<CreditsPage />} />
              <Route path="tutorial" element={<TutorialPage />} />
              <Route path=":roomCode" element={<GameStateProvider><GamePage /></GameStateProvider>} />
            </Route>
          
            {/* <Route path="*" element={<NoPage />} /> */}
          </Routes>
        </AudioProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
  
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
